import React, { useEffect } from "react";
import Editor from "../../../components/form/Editor";
import Input from "../../../components/form/Input";
import Select from "../../../components/form/Select";
import useForm from "../../../hooks/useForm";
import Button from "../../../components/form/Button";
import useMutation from "../../../hooks/useMutation";

import { planAddEdit } from "../../../services/plansService";
import Tabs from "../../../components/elements/Tabs";

const validation = {
  name: { required: true, message: "User name is required" },
  // "planPricingData.price": { required: true, message: "Price is required" },
};

const intervalOptions = [
  // { name: "Triennial", value: "triennial" },
  // { name: "Biennial", value: "biennial" },
  { name: "Yearly", value: "yearly" },
  // { name: "Half Yearly", value: "half_yearly" },
  { name: "Quarterly", value: "quarterly" },
  { name: "Monthly", value: "monthly" },
  { name: "Weekly", value: "weekly" },
  { name: "Daily", value: "daily" },
];
const productTypeOptions = [
  { name: "Plan", value: "plan" },
  { name: "Topup", value: "topup" },
];

const ManagePlan = ({ getResponse = () => {}, close = () => {}, data }) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({
    validationRules: validation,
    initialState: {
      name: "",
      planPricingData: {
        price: "",
        priceDescription: "",
      },
      // description: "",
      // price: "",
      // contentCount: "",
      productType: "",
      interval: "",
      validUpto: "",
      features: [{ name: "" }],
      // highLightTag: [{ icon: "", name: "", color: "" }],
    },
  });

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({
        ...data,
        planPricingData: {
          price: data?.planPricingData?.price ?? "",
          priceDescription: data?.planPricingData?.priceDescription ?? "",
        },
      });
    }
  }, [data]);
  const { mutate, isPending: isLoading } = useMutation({
    mutationFn: async (val) => {
      const payload = {
        ...val,
        ...(val.productType === "topup" && { interval: undefined }),
        ...(val.productType === "plan" && { validUpto: undefined }),
        ...(data?._id && { id: data?._id }),
        price: val.planPricingData?.price,
        priceDescription: val.planPricingData?.priceDescription,
      };
      delete payload.planPricingData;
      if (payload.interval === undefined) {
        delete payload.interval;
      }
      if (payload.validUpto === undefined) delete payload.validUpto;
      return await planAddEdit(payload);
    },
    onSuccess: (res) => {
      getResponse(res);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const featureGenerateHandler = () => {
    setFieldsValue({
      features: [...values?.features, { name: "" }],
    });
  };
  // const highLightTagGenerateHandler = () => {
  //   setFieldsValue({
  //     highLightTag: [
  //       ...values?.highLightTag,
  //       // { icon: "", name: "", color: "" },
  //     ],
  //   });
  // };

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <Tabs
        items={[
          {
            label: "General",
            icon: "fa-regular fa-gear",
            content: (
              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12">
                  <Input
                    label="Plan Name"
                    inputPlaceholder="Enter Plan Name"
                    inputName="name"
                    value={values?.name}
                    onChange={handleChange}
                    {...formValidate(errors, "name")}
                  />
                </div>

                {/* <div className="col-span-6">
                  <Input
                    label="Content Count"
                    inputPlaceholder="Enter Content Count"
                    inputType="number"
                    inputName="contentCount"
                    value={values?.contentCount}
                    onChange={handleChange}
                  />
                </div> */}

                <div className="col-span-6">
                  <Input
                    label="Price"
                    inputPlaceholder="Enter Price"
                    // inputName="planPricingData.price"
                    inputType="number"
                    value={values?.planPricingData?.price}
                    // onChange={handleChange}
                    onChange={(e) => {
                      setFieldsValue({
                        planPricingData: {
                          ...values.planPricingData,
                          price: e.target.value,
                        },
                      });
                    }}
                    {...formValidate(errors, "planPricingData.price")}
                  />
                </div>
                <div className="col-span-6">
                  <Input
                    label="Button Label"
                    inputPlaceholder="Enter Button Label"
                    // inputName="planPricingData.priceDescription"
                    inputType="text"
                    value={values?.planPricingData?.priceDescription}
                    // onChange={handleChange}

                    onChange={(e) => {
                      setFieldsValue({
                        planPricingData: {
                          ...values.planPricingData,
                          priceDescription: e.target.value,
                        },
                      });
                    }}
                    {...formValidate(
                      errors,
                      "planPricingData.priceDescription"
                    )}
                  />
                </div>
                {data?.highLightTag === 1 && (
                  <div className="col-span-6">
                    <Input
                      label="HighLight Text"
                      inputPlaceholder="Enter HighLight Text"
                      inputName="highLightText"
                      inputType="text"
                      value={values?.highLightText}
                      onChange={handleChange}
                      {...formValidate(errors, "highLightText")}
                    />
                  </div>
                )}
                {/* <div className="col-span-6">
                  <Select
                    label="Product Type"
                    placeholder="Select  Product Type"
                    selectedValue={values?.productType}
                    dropdownData={productTypeOptions}
                    // setSelectedValue={(val) =>
                    //   handleChange({ target: { name: "productType", value: val } })
                    // }
                    setSelectedValue={(val) => {
                      handleChange({
                        target: { name: "productType", value: val },
                      });
                      if (val === "topup") {
                        setFieldsValue({ interval: "" });
                      } else if (val === "plan") {
                        setFieldsValue({ validUpto: "" });
                      }
                    }}
                  />
                </div>
                {values?.productType === "topup" && (
                  <div className="col-span-6">
                    <Input
                      label="Valid Upto (in days)"
                      inputPlaceholder="Enter number of days"
                      inputName="validUpto"
                      inputType="number"
                      value={values?.validUpto}
                      onChange={handleChange}
                      {...formValidate(errors, "validUpto")}
                    />
                  </div>
                )}

                {values?.productType !== "topup" && (
                  <div className="col-span-6">
                    <Select
                      label="Interval"
                      placeholder="Select Interval"
                      selectedValue={values?.interval}
                      dropdownData={intervalOptions}
                      setSelectedValue={(val) =>
                        handleChange({
                          target: { name: "interval", value: val },
                        })
                      }
                    />
                  </div>
                )} */}
              </div>
            ),
          },

          /* Description */
          /* <div className="col-span-12">
          <Editor
            label="Description"
            value={values?.description}
            onChange={(val) => {
              handleChange({ target: { name: "description", value: val } });
            }}
            {...formValidate(errors, "description")}
          />
        </div> */
          {
            label: "Features",
            icon: "fa-regular fa-star",
            content: (
              <>
                {/* Features List */}

                <div className="col-span-12 space-y-4">
                  <label className="font-semibold text-sm">Features</label>
                  {values?.features?.map((feature, i) => (
                    <div key={i} className="flex space-x-4 items-end">
                      <div className="w-full">
                        <Input
                          label={`Feature Name ${i + 1}`}
                          value={feature?.name}
                          onChange={(e) => {
                            const updated = [...values?.features];
                            updated[i].name = e.target.value;
                            setFieldsValue({ features: updated });
                          }}
                        />
                      </div>
                      {/* <div className="w-1/2">
                <Input
                  label={`Count ${i + 1}`}
                  value={feature?.count}
                  inputType="number"
                  onChange={(e) => {
                    const updated = [...values?.features];
                    updated[i].count = e.target.value;
                    setFieldsValue({ features: updated });
                  }}
                />
              </div> */}
                      <Button
                        buttonIcon={"fa-regular fa-trash-can"}
                        buttonClasses={"!bg-transparent !text-chestnut-rose"}
                        buttonIconPosition={"left"}
                        buttonFunction={() => {
                          setFieldsValue({
                            features: values?.features?.filter(
                              (_, index) => i !== index
                            ),
                          });
                        }}
                      />
                    </div>
                  ))}
                  <Button
                    buttonLabel="Add Feature"
                    buttonClasses="!text-chestnut-rose !h-6 !p-0 !rounded-none !bg-transparent"
                    buttonFunction={featureGenerateHandler}
                  />
                </div>

                {/* highLightTag List */}
                {/* <div className="col-span-12 space-y-4">
                  <label className="font-semibold text-sm">
                    High Light Tags
                  </label>
                  {values?.highLightTag?.map((highLightTag, i) => (
                    <div key={i} className="flex space-x-4 items-end">
                      <div className="w-1/3">
                        <Input
                          label={`High Light Tag Icon ${i + 1}`}
                          inputPlaceholder="fa-regular fa-pen-ruler"
                          value={highLightTag?.icon}
                          onChange={(e) => {
                            const updated = [...values?.highLightTag];
                            updated[i].icon = e.target.value;
                            setFieldsValue({ highLightTag: updated });
                          }}
                        />
                      </div>

                      <div className="w-1/3">
                        <Input
                          label={`High Light Tag Name ${i + 1}`}
                          inputPlaceholder={'8.5" x 11" Pages'}
                          value={highLightTag?.name}
                          onChange={(e) => {
                            const updated = [...values?.highLightTag];
                            updated[i].name = e.target.value;
                            setFieldsValue({ highLightTag: updated });
                          }}
                        />
                      </div>
                      <div className="w-1/3">
                        <Input
                          label={`High Light Tag Color ${i + 1}`}
                          inputPlaceholder="text-purple"
                          value={highLightTag?.color}
                          onChange={(e) => {
                            const updated = [...values?.highLightTag];
                            updated[i].color = e.target.value;
                            setFieldsValue({ highLightTag: updated });
                          }}
                        />
                      </div>
                      <Button
                        buttonIcon={"fa-regular fa-trash-can"}
                        buttonClasses={"!bg-transparent !text-chestnut-rose"}
                        buttonIconPosition={"left"}
                        buttonFunction={() => {
                          setFieldsValue({
                            highLightTag: values?.highLightTag?.filter(
                              (_, index) => i !== index
                            ),
                          });
                        }}
                      />
                    </div>
                  ))}
                  <Button
                    buttonLabel="Add High Light Tag"
                    buttonClasses="!text-chestnut-rose !h-6 !p-0 !rounded-none !bg-transparent"
                    buttonFunction={highLightTagGenerateHandler}
                  />
                </div> */}
              </>
            ),
          },
        ]}
      />

      {/* Submit and Cancel */}
      <div className="col-span-12 mt-5 flex justify-center gap-4">
        <Button
          buttonType="submit"
          buttonLabel="Save"
          buttonClasses="!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
          {...(isLoading && {
            loading: true,
            buttonIconPosition: "left",
            isDisable: true,
          })}
        />
        <Button
          buttonLabel="Cancel"
          buttonClasses="!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
          buttonFunction={close}
        />
      </div>
      {/* </div> */}
    </form>
  );
};

export default ManagePlan;
